{
  "name": "@mux/app",
  "version": "0.1.0-alpha.1",
  "description": "",
  "type": "module",
  "scripts": {
    "test": "vitest run",
    "test:unit": "vitest run",
    "bun-canary": "bunx bun@1.4.3-canary.20261017.1",
    "typecheck": "bun run bun-canary check",
    "lint": "bun run bun-canary lint",
    "start": "vite",
    "dev": "vite",
    "build": "vite build",
    "build:mermaid-check": "bun scripts/mermaid-check/build.mjs",
    "bundle:report": "bun scripts/bundle-report.mjs",
    "bundle:check": "bun run build && bun run bundle:report",
    "serve": "vite preview"
  },
  "license": "MIT",
  "engines": {
    "bun": ">=1.4.2"
  },
  "devDependencies": {
    "@happy-dom/global-registrator": "20.0.11",
    "@tailwindcss/vite": "4.1.11",
    "@types/node": "22.13.9",
    "@types/novnc__novnc": "^1.6.0",
    "fake-indexeddb": "^6.2.4",
    "typescript": "7.0.2",
    "vite": "8.3.3",
    "vite-plugin-solid": "2.11.14",
    "vitest": "5.0.3"
  },
  "dependencies": {
    "@kobalte/core": "0.13.11",
    "@novnc/novnc": "^1.7.0",
    "@pierre/diffs": "1.6.0",
    "@solidjs/meta": "0.29.4",
    "@solidjs/router": "0.15.4",
    "@tanstack/virtual-core": "3.17.1",
    "@thisbeyond/solid-dnd": "0.7.5",
    "diff": "9.0.0",
    "dompurify": "^3.4.1",
    "fuzzysort": "3.1.0",
    "ghostty-web": "https://github.com/anomalyco/ghostty-web/archive/83c0a07b8628b748aed073b232cb4b52a6ca11c1.tar.gz",
    "katex": "^0.16.45",
    "marked": "18.1.1",
    "marked-shiki": "1.2.1",
    "pdfjs-dist": "^5.7.284",
    "pele": "1.6.0",
    "shiki": "^4.4.2",
    "solid-js": "1.9.10",
    "tailwindcss": "4.1.11"
  },
  "patchedDependencies": {
    "@kobalte/core@0.13.11": "patches/@kobalte%2Fcore@0.13.11.patch",
    "@pierre/theming@1.0.1": "patches/@pierre%2Ftheming@1.0.1.patch",
    "solid-presence@0.1.8": "patches/solid-presence@0.1.8.patch"
  }
}
